import { Button } from "@/components/ui/button";
import { QrCode, ShoppingBag, Star } from "lucide-react";
import heroImage from "@/assets/hero-independence.jpg";

const HeroSection = () => {
  const scrollToCatalog = () => {
    const catalogSection = document.getElementById("catalog");
    catalogSection?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="min-h-screen relative overflow-hidden bg-gradient-hero">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
        style={{ backgroundImage: `url(${heroImage})` }}
      />

      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-16 h-16 bg-primary/10 rounded-full animate-float" />
      <div className="absolute top-40 right-20 w-12 h-12 bg-accent/10 rounded-full animate-float delay-1000" />
      <div className="absolute bottom-32 left-20 w-20 h-20 bg-primary/5 rounded-full animate-float delay-2000" />

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 pt-20 pb-16">
        <div className="text-center max-w-4xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-gradient-independence text-primary-foreground px-6 py-3 rounded-full mb-8 animate-fade-in-up shadow-independence">
            <Star className="w-5 h-5" />
            <span className="font-semibold">HUT RI ke-80</span>
            <Star className="w-5 h-5" />
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold font-display text-foreground mb-6 animate-fade-in-up delay-200">
            <span className="text-primary">Bazaar</span>{" "}
            <span className="text-accent">Kemerdekaan</span>
            <br />
            <span className="text-2xl md:text-4xl lg:text-5xl font-normal text-muted-foreground">
              Digital Marketplace
            </span>
          </h1>

          {/* Description */}
          <p className="text-lg md:text-xl text-muted-foreground mb-12 max-w-2xl mx-auto animate-fade-in-up delay-400">
            Merayakan kemerdekaan Indonesia dengan berbelanja produk lokal
            terbaik. Scan QR code untuk memulai pengalaman belanja digital yang
            tak terlupakan!
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-fade-in-up delay-600">
            <Button
              variant="heroRed"
              size="xl"
              onClick={scrollToCatalog}
              className="w-full sm:w-auto"
            >
              <ShoppingBag className="w-5 h-5" />
              Mulai Belanja
            </Button>

            <Button
              variant="heroWhite"
              size="xl"
              onClick={() => (window.location.href = "/sell-product")}
              className="w-full sm:w-auto"
            >
              <ShoppingBag className="w-5 h-5" />
              Titip Jual Produk
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-8 mt-16 animate-fade-in-up delay-800">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-primary">
                50+
              </div>
              <div className="text-sm text-muted-foreground">Produk Lokal</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-accent">
                100%
              </div>
              <div className="text-sm text-muted-foreground">
                Buatan Indonesia
              </div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-primary">
                24/7
              </div>
              <div className="text-sm text-muted-foreground">Buka Terus</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-primary rounded-full flex justify-center">
          <div className="w-1 h-3 bg-primary rounded-full mt-2 animate-pulse" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
